import type {
  ReactElement,
  DetailedHTMLProps,
  InputHTMLAttributes,
} from "react";
import { forwardRef } from "react";
import styles from "./Checkbox.module.scss";
import classNames from "classnames";

type CheckboxProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref): ReactElement => {
    const { className, ...restProps } = props;

    function handleSetRef(_ref: HTMLInputElement) {
      if (typeof ref === "function") {
        ref(_ref);
      }
    }

    return (
      <div className={styles.checkbox}>
        <input
          {...restProps}
          ref={handleSetRef}
          className={classNames(styles.checkboxInput, className)}
          type="checkbox"
        />
        {/*https://dev.w3.org/html5/html-author/charref* check character*/}
        <span aria-hidden={true} className={styles.checkboxIcon}>
          &#10003;
        </span>
      </div>
    );
  },
);

Checkbox.displayName = "CheckBox";

export { Checkbox };
